/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const ListSubGroupsResponse = zod.object({
  nextCursor: zod.string().nullable(),
  subGroups: zod.array(
    zod.object({
      groupActorUuid: zod.uuid(),
      id: zod.string(),
      name: zod.string(),
      visibility: zod.enum(['PUBLIC', 'PRIVATE', 'SECRET']),
    }),
  ),
  totalCount: zod.int(),
});

export type ListSubGroupsResponse = zod.input<typeof ListSubGroupsResponse>;
export type ListSubGroupsResponseOutput = zod.output<typeof ListSubGroupsResponse>;
